import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="poll"
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 10000 }
  }

  connect() {
    this.stopWhenReady = this.stopWhenReady.bind(this)
    this.element.addEventListener("turbo:frame-render", this.stopWhenReady)
    this.startPolling()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-render", this.stopWhenReady)
    this.stopPolling()
  }

  startPolling() {
    if (this.timer) return

    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  stopPolling() {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
  }

  refresh() {
    if (document.hidden) return
    if (!this.element.reload) return

    this.element.reload()
  }

  stopWhenReady() {
    if (this.element.childElementCount === 0) this.stopPolling()
  }
}
